const OfferWorkflowStatusEnum = Object.freeze({
    DRAFT: 'DRAFT',
    LIVE: 'LIVE'
});

export default OfferWorkflowStatusEnum;
